(function (angular) {
  angular
    .module('acme.view.application.membership.cancel.controllers', [
      'ui.router',
      'acme.common.service.api',
      'acme.common.factory.notice',
      'acme.view.application.orders.refund.confirmModal.controllers',
    ])
    .controller('MembershipCancelController', MembershipCancelController);

  MembershipCancelController.$inject = [
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'ApiService',
    'NoticeFactory',
    'MembershipData',
  ];

  function MembershipCancelController($scope, $state, $timeout, $uibModal, ApiService, NoticeFactory, MembershipData) {
    var ctrl = this;

    ctrl.vm = {
      membership: {},
      charges: {},
      notes: '',
    };

    ctrl.isLoaded = false;
    ctrl.disableActions = false;

    ctrl.organizationOrderInput = {};

    $scope.membershipCancel = {
      model: {},
      details: {
        columns: 2,
        data: 'membershipCancel.model',
        sorting: false,
        include: ['membershipNumber', 'membership', 'primaryCardholder'],
      },
    };

    ctrl.notice = new NoticeFactory();

    ctrl.$onInit = function () {
      if (MembershipData.data && MembershipData.data.success) {
        ctrl.initMembershipData();
        ctrl.getRefundData();
      }

      ctrl.initHeader();
    };

    ctrl.initHeader = function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Cancel Membership and Refund',
        buttonLeft: {
          label: '< Back',
          action: function () {
            ctrl.cancel();
          },
        },
        buttonRight:
          ctrl.isLoaded && !ctrl.disableActions
            ? {
                label: 'Confirm Cancellation and Refund',
                action: function () {
                  ctrl.complete();
                },
              }
            : null,
      });
    };

    ctrl.initMembershipData = function () {
      var model = {};
      var data = MembershipData.data.payload;
      var primaryCardholder = data.cardholders.find(function (item) {
        return item.cardType === 'primary' || item.primaryCard === 'yes';
      });

      ctrl.vm.membership = MembershipData.data.payload;

      model = Object.assign({}, data, {
        membershipNumber: data.acmeMembershipNumber,
        membership: [data.membershipCategory, data.offeringName].join(' '),
        primaryCardholder: primaryCardholder ? primaryCardholder.name : '',
      });

      $scope.membershipCancel.model = model;
    };

    ctrl.getRefundData = function () {
      var membership = MembershipData.data.payload;

      ctrl.organizationOrderInput = {
        memberships: [
          {
            itemType: 'MembershipCancel',
            membershipInfo: {
              membershipId: membership.id,
              membershipOfferingId: membership.offeringId,
              waiveBenefits: false,
              pricePointId: membership.pricePointId,
              notifyGiftRecipient: false,
              isGift: membership.isGift,
              membershipCategoryId: membership.categoryId,
              membershipCards: membership.cardholders,
            },
          },
        ],
      };

      return ApiService.orders.checkout.charges(ctrl.organizationOrderInput).then(
        function (res) {
          ctrl.vm.charges = ctrl.processCharges(res.data.payload);
          ctrl.isLoaded = true;

          ctrl.initHeader();
        },
        function (res) {
          ctrl.notice.showErrorMessages([{ message: res.data.error }]);
          ctrl.isLoaded = true;
          ctrl.disableActions = true;
        }
      );
    };

    ctrl.processCharges = function (payload) {
      return Object.assign({}, payload, {
        refundDetails: payload.refundDetails
          ? payload.refundDetails.map(function (detail) {
              switch (detail.paymentMethod) {
                case 'CreditCard':
                  detail.paymentMethodDescription = 'Credit Card x' + detail.ccLastFourDigits; 
                  break;

                default:
                  detail.paymentMethodDescription = detail.paymentMethod;
                  break;
              }
              return detail;
            })
          : null,
      });
    };

    ctrl.cancel = function () {
      window.history.back();
    };

    ctrl.gotoOrders = function (orderId) {
      $state.go('application.orders.detail.summary', {
        orderId: orderId,
      });
    };

    ctrl.complete = function () {
      if (!ctrl.isLoaded || ctrl.disableActions) {
        return;
      }

      ctrl.isLoaded = false;

      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ctrl.cancelModal = $uibModal.open({
        templateUrl: 'views/application/views/membership/cancel/confirm.tpl.html',
        controller: 'OrdersRefundConfirmModalController',
        resolve: {
          currentRefund: function () {
            return null;
          },
        },
      });

      ctrl.cancelModal.result
        .then(function () {
          var membership = MembershipData.data.payload;

          var items = ctrl.organizationOrderInput.memberships.map(function (item) {
            return Object.assign({}, item, { quantity: 1 });
          });

          var order = {
            membershipId: membership.id,
            saleChannel: 'insideSalesIndividual',
            paymentMethod: 'Cash',
            shoppingCart: {
              items: items,
              verifyEntitlements: false,
              membershipCategoryId: membership.categoryId,
              membershipId: membership.id,
              saleChannel: 'insideSalesIndividual',
            },
            notes: ctrl.vm.notes,
          };

          return ApiService.orders.checkout
            .cancelAndRefund(order)
            .then(function (res) {
              var payload = res.data.payload;

              ctrl.notice.showSuccessMessages([{ message: 'Membership Canceled' }]);

              ctrl.isLoaded = true;
              ctrl.disableActions = true;

              $timeout(function () {
                if (payload.id) {
                  ctrl.gotoOrders(payload.id);
                } else {
                  ctrl.cancel();
                }
              }, 1500);
            })
            .catch(function (res) {
              ctrl.notice.showErrorMessages([{ message: res.data.error }]);
              ctrl.isLoaded = true;
            });
        })
        .catch(function () {
          ctrl.isLoaded = true;
        });
    };
  }
})(window.angular);
